import { Injectable } from '@angular/core';
import { BaseProvider } from './base-provider';
import { LoadingNotifier } from '../notifiers/loading-notifier';
import { LoadingState } from '../states/loading-state';

@Injectable({ providedIn: 'root' })
export class LoadingProvider extends BaseProvider<LoadingNotifier, LoadingState> {
  constructor() {
    super(LoadingNotifier);
  }
}
